<div class="compliance-container">
	<div class="compliance-container-inner">
		<img
			class="d-none d-md-block orange-pattern-overlay"
			src="../../assets/img/orange-pattern.png"
			alt=""
		/>
		<img
			class="d-md-none orange-pattern-overlay"
			src="../../assets/img/orange-pattern-mobile.png"
			alt=""
		/>
		<div class="container text-center">
			<h2 class="compliance-header">
				Continuous Compliance for <br class="d-none d-sm-block" />
				Government Agencies
			</h2>

			<div class="row">
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/simplify.svg"
						alt=""
					/>
					<div class="challenges-list-head">
						Simplify with Automation
					</div>
					<div class="challenges-list-content">
						Build security plans in a few clicks, plan assessment
						schedules, and manage all
						<br class="d-none d-xl-block" />
						compliance checks against your
						<br class="d-none d-xl-block" />
						security controls.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/stay-ahead.svg"
						alt=""
					/>
					<div class="challenges-list-head">
						Stay Ahead of Schedule
					</div>
					<div class="challenges-list-content">
						Create Plan of Action and Milestones
						<br class="d-none d-xl-block" />
						(POAMs), track activity, and manage
						<br class="d-none d-xl-block" />
						compliance activities in an encrypted,
						<br class="d-none d-xl-block" />
						secure compliance management platform.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/easily-access.svg"
						alt=""
					/>
					<div class="challenges-list-head">Easily Access</div>
					<div class="challenges-list-content">
						Review your organization’s state of
						<br class="d-none d-xl-block" />
						compliance across all information systems
						<br class="d-none d-xl-block" />
						with beautiful, intuitive real-time reports that
						<br class="d-none d-xl-block" />
						are easy to share and understand.
					</div>
				</div>
			</div>
			<a href="https://go.regscale.com/RegScale-Create-Account">
				<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
					Find Out More
				</button></a
			>
		</div>
	</div>
</div>
